import { ColorPicker } from "antd";
import { Color } from "antd/es/color-picker";

import { BaseColorPickerProps } from "@/components_v2/FormFields/ColorPicker/types";
import BaseButton from "@/components_v2/Button/BaseButton";
import "./styles.css";

const BaseColorPicker = ({
  onChange,
  defaultValue,
  ...props
}: BaseColorPickerProps) => {
  const handleOnChange = (value: Color) => {
    onChange(value.toHexString());
  };

  const revertColorToDefault = () => {
    if (defaultValue) {
      onChange(defaultValue);
    }
  };

  return (
    <div className="base-color-picker-container">
      <ColorPicker
        defaultValue={defaultValue}
        {...props}
        onChangeComplete={handleOnChange}
        panelRender={(panel) => {
          return (
            <div className="base-color-picker-panel-container">
              {panel}
              <BaseButton
                size="small"
                variant="tertiary"
                isFullWidth
                onClick={revertColorToDefault}
              >
                Revert to default
              </BaseButton>
            </div>
          );
        }}
      />
    </div>
  );
};

export default BaseColorPicker;
